export const filterProfilesByRecipeCapability = (
  profiles = [],
  emitsRecipe,
) =>
  profiles.filter(
    (profile) =>
      profile?.enabled !== false &&
      Boolean(profile?.emitsRecipe) === emitsRecipe,
  );

export const findProfileByRecipeCapability = (
  profiles = [],
  profileId,
  emitsRecipe,
) =>
  filterProfilesByRecipeCapability(profiles, emitsRecipe).find(
    (profile) => Number(profile?.id) === Number(profileId),
  );

export const buildProfileReference = (profile) => ({
  id: profile?.id,
  name: profile?.name,
  validateEmail: profile?.validateEmail,
  isAdmin: profile?.isAdmin,
});
